import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { LIcon, LMarker } from '@vue-leaflet/vue-leaflet'
  import { toRefs } from 'vue'

  import { TCoordinates } from '@/types/workouts'

  interface Props {
    markerCoordinates: TCoordinates
    isStart: boolean
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    markerCoordinates: null,
    isStart: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    markerCoordinates: TCoordinates
    isStart: boolean
  }

  

  const { isStart, markerCoordinates } = toRefs(props)

return (_ctx: any,_cache: any) => {
  return (_unref(markerCoordinates).latitude)
    ? (_openBlock(), _createBlock(_unref(LMarker), {
        key: 0,
        "lat-lng": [_unref(markerCoordinates).latitude, _unref(markerCoordinates).longitude]
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(LIcon), {
            "icon-url": `/img/workouts/${_unref(isStart) ? 'start' : 'finish'}.svg`,
            iconSize: [15, 15]
          }, null, 8, ["icon-url"])
        ]),
        _: 1
      }, 8, ["lat-lng"]))
    : _createCommentVNode("", true)
}
}

})